export default __webpack_public_path__ + "static/media/phoneInTalk.d3b57868.svg";